import { FeatureConfiguration } from "..";
import { multiInstanceMiddleware } from "./middleware/multiInstanceMiddleware";
import { reducer as appInstanceReducer } from "./reducers";
export * from "./reducers";

export default function (config: FeatureConfiguration) {
    config.middleware.push(multiInstanceMiddleware());
    config.reducers.appInstance = appInstanceReducer;
}
